import {
  eventListener,
  IStaleData,
  StaleDataType,
  TOPICS,
} from "@origin-digital/event-dispatcher";
import { useEffect } from "react";

export const useOnStaleUserData = (callback: () => void) => {
  useEffect(() => {
    const unsubscribe = eventListener.addMulticastListener(
      TOPICS.STALE_DATA,
      ({ payload: { type } }: IStaleData) => {
        if (type === StaleDataType.USER_DATA) {
          callback();
        }
      }
    );
    return () => unsubscribe();
  });
};
